var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-card',{attrs:{"flat":"","height":"100%","tile":""}},[_c('NavigationBar',{attrs:{"is-home-page":false}}),_c('CheckInOptions'),_c('div',{staticClass:"middle-block-divider"})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }